import React from "react";
import Button from "../../form/Button";
import { useTranslation } from "react-i18next";
const CallToAction = () => {
  const { t } = useTranslation();

  const ctaSectionData = {
    bgColorClass: "bg-text-primary",
    heading: t("Ready to Simplify Your Next Event?"),
    subheading: t(
      "Join thousands of organisers using Dancebrite to plan smarter, sell faster, and run better events."
    ),
    button: {
      label: t("Get Started for Free"),
      link: "/signup",
      labelClasses: "text-2xl font-bold text-white capitalize ",
      buttonClasses: "h-16 bg-secondary-gradient",
    },
  };

  return (
    <section className={`relative py-16 lg:py-24 bg-text-primary`}>
      <div className="max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl w-full mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-14 2xl:gap-24 3xl:gap-28">
          <div className="relative space-y-5">
            <h2 className="text-gray-500 text-2xl md:text-3xl 2xl:text-4xl font-bold">
              {ctaSectionData.heading}
            </h2>
            <div className="text-gray-500 text-lg md:text-xl 2xl:text-2xl">
              {ctaSectionData.subheading}
            </div>
          </div>
          <div className="flex items-center justify-end">
            <Button
              buttonLabel={ctaSectionData.button.label}
               buttonLabelClasses={`${ctaSectionData.button.labelClasses} md:text-2xl text-xl`}
              buttonClasses={ctaSectionData.button.buttonClasses}
              buttonHasLink={true}
              buttonLink={ctaSectionData.button.link}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
